import React, {useState} from "react";
import { Container, Row, Col, Button, Card, Form, Modal } from "react-bootstrap";
import styles from "./Assistance.module.css";
import CashIcon from "../../assets/cash.svg";
import FoodIcon from "../../assets/food.svg";
import SubsidyIcon from "../../assets/subsidy.svg";
import SupportIcon from "../../assets/support.svg";
import AppliedIcon from "../../assets/applied.svg";
import Check from "../../assets/check-verified-02 (1).png"
import Clip from "../../assets/Icon (1).png"
import NewHeader from "../../Components/NewHeader";




export default function Assistance() {
  const [showModal, setShowModal] = useState(false);
const [show, setShow] = useState(false);
  const handleClose = () => { 
    setShow(false) 
  };
  const handleShow = () => { 
    setShowModal(false);
    setShow(true) 
  };
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
<NewHeader />
    <div className={styles.wrapper}>
      <div className={styles.headerRow}>
        <div>
          <p className={styles.smallHeader}>— WELFARE MEMBERS</p>
          <h3 className={styles.title}>Apply for Assistance</h3>
          <p className={styles.subtitle}>
            Programmes currently open for applications. Apply for any you qualify for
          </p>
        </div>
      </div>
      <div className={styles.nxtCont}>
        <div className={styles.dot} />
        <span className={styles.nxtText}>CURRENTLY OPEN - 4 PROGRAMMES</span>
      </div>

    <div className={styles.cardsRow}>
        {[
          { title: "Cash Transfer", text: "Monthly cash support for qualifying households" },
          { title: "Food Support", text: "Monthly food baskets for households with children under 5" },
          { title: "Healthcare Subsidy", text: "Free access to basic healthcare at designated centers" },
          { title: "School Support Grant", text: "Fees, uniforms and materials for school-age children" },
        ].map((card, index) => (
          <div key={index} className={styles.cardings}>
            <img src={CashIcon} alt={card.title} className={styles.cardIcons} />
            <h5 className={styles.cardTitle}>{card.title}</h5>
            <p className={styles.cardText}>{card.text}</p>
            <div className={styles.btnCont}>
              <p>Verified Households</p>
              <Button
                variant="outline-success"
                className={styles.applyBtn}
                onClick={handleOpenModal} // Open modal on click
              >
                Apply
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.nxtConts}>
        <div className={styles.dot} />
        <span className={styles.nxtText}>OTHER PROGRAMMES</span>
      </div>
      <div className={styles.progCont}>
        <div className={styles.progRow}>
          <div className={styles.proggRowCont1}>
            <img src={CashIcon} alt="Cash Assistance" className={styles.cardIcons} />
            <div className={styles.proggRowCont}>
              <h5 className={styles.cardTitle}>Housing Improvement Support</h5>
              <p className={styles.cardTextt}>
                Support for basic housing repairs and sanitation improvements
              </p>
            </div>
          </div>
          <div className={styles.progrowEnd}>
              <h5 className={styles.progRowEndText}>Opens Q3 2026</h5>
          </div>

        </div>
      </div>
<Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className="custom-modal">
          <Modal.Title style={{fontSize: 24, color: '#166534', fontWeight: 600, fontFamily: 'Manrope, sans-serif', borderBottom: 0}}>Apply for Assistance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{color: '#1E293B', fontSize: 14, fontWeight: 500, fontFamily: 'Manrope, sans-serif'}}>Why are you applying for this programme?</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                style={{color: '#1E293B', fontSize: 14, fontWeight: 500, fontFamily: 'Manrope, sans-serif', border: '0.5px solid #16A34A', borderRadius: 8}}
                placeholder="Briefly describe your need"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={{color: '#1E293B', fontSize: 14, fontWeight: 500, fontFamily: 'Manrope, sans-serif'}}>Number of household members who will benefit</Form.Label>
              <Form.Control type="number" placeholder="e.g. 3" style={{color: '#1E293B', height: 48, fontSize: 14, fontWeight: 500, fontFamily: 'Manrope, sans-serif', border: '0.5px solid #16A34A', borderRadius: 8}}/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseModal} className={styles.cancelBtn}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleShow} className={styles.submitBtn}>
            Submit Application
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
      show={show}
      onHide={handleClose}
      centered
      
      // backdrop="static"
      className={styles.modalWrapper}
    >
      <Modal.Body className={styles.modalBody}>
        {/* Icon */}
        <div className={styles.iconWrapper}>
          <img src={Check} size={40} />
        </div>

        {/* Title */}
        <h3 className={styles.titless}>Application Submitted!</h3>

        {/* Subtitle */}
        <p className={styles.subtitless}>
         Your application has been submitted successfully. A field agent will review your application and reach out to you within 10–14 working days
        </p>

        {/* Reference Box */}
        <div className={styles.refBox}>
          <span className={styles.refLabel}>APPLICATION ID</span>
          <div className={styles.refNumber}>
            OG-HH-2026-04917
            {/* <span className={styles.copyIcon}>📋</span> */}
            <img src={Clip} size={20} className={styles.copyIcon} />
          </div>
        </div>

        {/* Button */}
        <button className={styles.loginBtn}>
         Done
        </button>
      </Modal.Body>
    </Modal>
    </div>
    </div>
  );
}
